// extracted by mini-css-extract-plugin
export default {"fullPage":"full-page-container_fullPage__DXojL","fullPageContainer":"full-page-container_fullPageContainer__2Tcmv"};